import { canAccessLeLens } from '~/utils/canAccessLeLens';

import useCurrentUser from './useCurrentUser';

export default function useCanAccessLeLens(): boolean {
  const { user } = useCurrentUser();
  return canAccessLeLens(user);
}
